import { useNavigate } from 'react-router-dom';
import { ChevronRight, X } from 'lucide-react';
import { useProject } from '@/context/ProjectContext';

interface ProjectBreadcrumbProps {
  projectName: string;
  currentPage: 'sitevisit' | 'quotation' | 'invoice' | 'cost' | 'report' | 'images';
}

const pages = [
  { id: 'sitevisit', label: 'Lawatan Tapak', path: '/site-visit' },
  { id: 'quotation', label: 'Sebut Harga', path: '/sebutharga' },
  { id: 'invoice', label: 'Invoice', path: '/invoice' },
  { id: 'cost', label: 'Nilai & Kos', path: '/nilai-kos-projek' },
  { id: 'report', label: 'Laporan Kerja', path: '/laporan-kerja' },
  { id: 'images', label: 'Gambar Projek', path: '/gambar-projek' },
];

export const ProjectBreadcrumb = ({ projectName, currentPage }: ProjectBreadcrumbProps) => {
  const navigate = useNavigate();
  const { setSelectedProject } = useProject();

  const handleNavigation = (path: string) => {
    navigate(path);
    // Scroll to top for better UX
    window.scrollTo(0, 0);
  };

  const handleClearSelection = () => {
    setSelectedProject(null);
  };

  return (
    <div className="bg-slate-50 border-b border-slate-200 px-6 py-3 mb-6">
      <div className="flex items-center gap-2 text-sm flex-wrap">
        <span className="font-semibold text-slate-700 bg-white px-3 py-1 rounded border border-slate-200">
          📋 {projectName}
        </span>
        <span className="text-slate-400">→</span>
        
        <div className="flex items-center gap-1 flex-wrap">
          {pages.map((page, idx) => (
            <div key={page.id} className="flex items-center gap-1">
              <button
                onClick={() => handleNavigation(page.path)}
                className={`px-3 py-1 rounded text-xs font-medium transition-colors ${
                  currentPage === page.id
                    ? 'bg-red-100 text-red-700 font-semibold'
                    : 'bg-white text-slate-600 hover:bg-slate-100 border border-slate-200'
                }`}
              >
                {page.label}
              </button>
              {idx < pages.length - 1 && <ChevronRight size={14} className="text-slate-300" />}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};